// extracted by mini-css-extract-plugin
module.exports = {"accept":"Accept_accept__25s1u","content":"Accept_content__3nLeg","avatar":"Accept_avatar__2J4EV"};